import {CustomerManageRegister} from "@/features/manage";
import {vars} from "@/shared/lib";
import {Column} from "@/shared/ui";
import {createFileRoute} from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/_layout/manage/customer-manage/register")({
	component: CustomerManageRegisterPage
});

function CustomerManageRegisterPage() {
	return (
		<Column fullWidth style={{gap: vars.size[16]}}>
			<CustomerManageRegister />
		</Column>
	);
}
